/**
 * de-DE catalogue. PROVISIONAL — best-effort translation of en-GB,
 * following standard Bundesdeutsch conventions (formal "Sie" register,
 * "Eszett" used where appropriate). Review by a native German speaker
 * before any German-market tenant goes live.
 */

import type { TranslationMap } from '../i18n';

export const DE_DE: TranslationMap = {
  common: {
    save: 'Änderungen speichern',
    saving: 'Speichern…',
    saved: 'Änderungen gespeichert.',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    loading: 'Wird geladen…',
    error_generic: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    sign_in: 'Anmelden',
    sign_out: 'Abmelden',
    back: 'Zurück',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    open: 'Öffnen',
    optional: 'Optional',
    required: 'Erforderlich',
  },

  nav: {
    home: 'Startseite',
    bookings: 'Buchungen',
    pets: 'Tiere',
    profile: 'Profil',
    payments: 'Zahlungen',
    credits: 'Guthaben',
    packs: 'Pakete',
    notifications: 'Benachrichtigungen',
    privacy: 'Datenschutz',
    book_now: 'Jetzt buchen',
    your_account: 'Ihr Konto',
  },

  account_home: {
    greeting: 'Hallo {{ name }}',
    greeting_anonymous: 'Willkommen',
    upcoming_bookings: 'Anstehende Buchungen',
    no_upcoming:
      'Keine anstehenden Buchungen — buchen Sie einen Aufenthalt oder einen Tag in der Tagesbetreuung.',
    your_pets: 'Ihre Tiere',
    no_pets: 'Wir haben noch keine Tiere für Sie gespeichert.',
    quick_actions: 'Schnellaktionen',
  },

  bookings: {
    page_title: 'Ihre Buchungen',
    upcoming: 'Anstehend',
    past: 'Vergangen',
    cancelled: 'Storniert',
    starts: 'Beginnt',
    ends: 'Endet',
    pet: 'Tier',
    service: 'Leistung',
    total: 'Gesamt',
    balance_due: 'Offener Betrag',
    status: 'Status',
    view_details: 'Details ansehen',
    cancel_booking: 'Buchung stornieren',
    request_refund: 'Erstattung anfordern',
    pay_balance: 'Restbetrag bezahlen',
    photos: 'Fotos',
    no_photos: 'Noch keine Fotos — unser Team veröffentlicht hier Updates während des Aufenthalts.',
    booking_id: 'Buchungsnummer',
  },

  pets: {
    page_title: 'Ihre Tiere',
    add_pet: 'Tier hinzufügen',
    no_pets: 'Sie haben noch keine Tiere gespeichert.',
    breed: 'Rasse',
    species: 'Art',
    weight: 'Gewicht',
    date_of_birth: 'Geburtsdatum',
    microchip: 'Mikrochip',
    vaccinations: 'Impfungen',
    notes: 'Notizen',
    upload_photo: 'Foto hochladen',
    vet_sharing: 'Tierarztfreigabe',
  },

  profile: {
    page_title: 'Profil',
    section_eyebrow: 'Ihr Konto',
    name_label: 'Name',
    name_placeholder: 'Ihr Name',
    phone_label: 'Telefon',
    email_label: 'E-Mail',
    email_help: 'Kontaktieren Sie uns, um Ihre E-Mail-Adresse zu ändern.',
    account_label: 'Konto:',
    language_label: 'Sprache',
    language_help: 'Wählen Sie die Sprache für Ihr Konto und Ihre Benachrichtigungen.',
    save_failed: 'Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    load_failed: 'Profil konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  },

  payments: {
    page_title: 'Zahlungen',
    history: 'Zahlungsverlauf',
    no_payments: 'Noch keine Zahlungen.',
    amount: 'Betrag',
    paid_on: 'Bezahlt am',
    method: 'Methode',
    reference: 'Referenz',
    receipt: 'Beleg',
    add_payment_method: 'Zahlungsmethode hinzufügen',
  },

  sign_in: {
    page_title: 'Anmeldung bei {{ accountName }}',
    page_title_default: 'Anmelden',
    email_label: 'E-Mail-Adresse',
    send_link: 'Anmeldelink senden',
    sending: 'Wird gesendet…',
    link_sent_title: 'Prüfen Sie Ihr Postfach',
    link_sent_body:
      'Wir haben einen Anmeldelink an {{ email }} gesendet. Er läuft in 15 Minuten ab.',
    consume_loading: 'Sie werden angemeldet…',
    consume_failed: 'Wir konnten Sie nicht anmelden. Der Link ist möglicherweise abgelaufen.',
    back_to_sign_in: 'Zurück zur Anmeldung',
  },
};
